import { StyleSheet } from 'react-native';
import {
  borderRadius,
  darkestGrey,
  fontFamily,
  fontFamilyBold,
} from '../../../constants/palette';
import {
  black,
  fontSizeMedium,
  textInputBorderStyle,
  textInputBorderWidth,
} from '../../../constants/palette';

export default StyleSheet.create({
  baseContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    flexDirection: 'column',
    backgroundColor: black,
  },

  container: {
    borderColor: 'rgba(64,64,64,0.6)',
    backgroundColor: darkestGrey,
    borderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
    flex: 1,
    flexDirection: 'column',
    padding: 10,
    margin: 10,
    width: 300,
  },

  commentText: {
    padding: 2,
    fontStyle: 'italic',
    fontSize: fontSizeMedium,
  },
  iconWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  feedbackCardContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'column',
    padding: 10,
  },
  rowTitle: {
    fontFamily: fontFamilyBold,
  },
  text: {
    fontFamily,
  },
});
